import { Component, ViewChild, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import {
  AgChart,
  AgChartOptions,
  AgChartInstance,
  AgCartesianChartOptions,
  AgLineSeriesOptions,
} from 'ag-charts-community';
import { AgCartesianSeriesMarker } from 'ag-charts-community';
import { getData } from './uvrData';

import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatDialogConfig } from '@angular/material/dialog';
import { UvrActionDialogComponent } from './uvr-action-dialog/uvr-action-dialog.component';
import { Router } from '@angular/router';
import { Console, log } from 'console';
import { UvrService } from '../services/uvr/uvr.service';
import { logErrors } from '../shared/logger';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataServiceService } from '../services/air-freight-validation/data-service.service';
import { AirfreightApicallsService } from '../services/air-freight-validation/airfreight-apicalls.service';
import { LookupService } from '../services/lookup/lookup.service';
import { Subscription, forkJoin } from 'rxjs';
import { OSPStateService } from '../services/osp-state.service';
import { checkInvAccess, roundUp, warningMessage } from '../constants';
import { BulkadjustmentService } from '../services/bulk-adjustment/bulkadjustment.service';
import { UVRChartDataExcelService } from './uvr-excel-service/uvr-chart-data-excel.service';
import { CustomTooltipComponent } from '../core/custom-tooltip/custom-tooltip.component';
import { PipeLookupService } from '../services/pipe-lookup/pipe-lookup.service';
import clone from 'clone';
import { DefaultService } from '../services/default.service';

@Component({
  selector: 'app-usage-vs-receipt',
  templateUrl: './usage-vs-receipt.component.html',
  styleUrls: ['./usage-vs-receipt.component.scss'],
})
export class UsageVsReceiptComponent implements OnInit, OnDestroy {
  @ViewChild('partGrid') partGrid;
  @ViewChild('manualAdjGrid') manualAdjGrid;
  @ViewChild('actionGrid') actionGrid;
  isExpendChart = false;
  successMessage = '';
  warningMessage = '';
  modalComponent = 'modal-component';
  masterList: any = [];
  renban = '';
  selectedDock: any = [];
  selectedPartNo: any;
  selectedKanban: any;
  selectedSpecialist: any;
  isRecalculateEnabled = true;
  dockList: any = [];
  partNoList: any = [];
  kanbanList: any = [];
  specialistList: any = [];
  rowdata: any = [];
  options: AgChartOptions;
  disableKanban;
  disablePartNumber;

  partnorowdata = [];
  manadjrowdata = [];
  actionrowdata = [];

  selectedCount: any;
  countDate: string;
  count: any = [];
  countCR = '';
  //chartOptions: AgChartOptions ;

  gridApi: GridApi;
  offset = 0;
  dataCount = 0;
  columnDefPartNo;
  columnDefManualAdj;
  morninggridoptions;
  columnDefAction = [];
  frameworkComponents = { customTooltip: CustomTooltipComponent };
  context;
  stockDtTo: any = [];
  stockDtFrom: any = [];
  dropDownchartOptions = [
    { chart_name: 'by number of lots', id: 1 },
    { chart_name: 'by total pieces', id: 2 },
    { chart_name: 'by number of days reqs', id: 3 },
  ];
  selectedchart = { chart_name: 'by number of lots', id: 1 };
  actionOptions = [
    // { action_name: 'Complete' },
    { action_name: 'Add Comment' },
    { action_name: 'Add to "To Be Counted"' },
    { action_name: 'Raise Manual Order' },
    { action_name: 'Raise Tap Request' },
    { action_name: 'Raise Air Order' },
    { action_name: 'Parts Information/Procurement' },
  ];


  // To handle selected action
  selectedAction = '';
  // Modal visibility control
  isModalVisible: boolean = false;

  comment: any;
  text1: any;
  text2: any;
  textDate: any;
  namcValue = localStorage.getItem('namcvalue');
  userName = localStorage.getItem('UserName');
  user: string;
  userRole: any;
  namcName: any;
  subscription$: Subscription;
  selectedDate: Date;
  partNo = '';
  supplier: any;
  access;
  accessEdit = false;
  stockDtFromHold: any = {};
  stockDtToHold: any = {};
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private uvrService: UvrService,
    private readonly spinner: NgxSpinnerService,
    private dataService: DataServiceService,
    private readonly airFreightService: AirfreightApicallsService,
    private readonly lookupService: LookupService,
    private readonly stateService: OSPStateService,
    private bulkadjustmentService: BulkadjustmentService,
    private chartService: UVRChartDataExcelService,
    private readonly pipeLookupService: PipeLookupService,
    private readonly defaultService: DefaultService
  ) {
    this.context = {
      componentParent: this,
    };
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
  ngOnInit(): void {
    this.access = checkInvAccess();
    this.accessEdit = this.access?.functionalityAccess?.edit || false;


    this.namcValue = localStorage.getItem('namcvalue');

    if (localStorage.getItem('workdayId')) {
      this.user = localStorage.getItem('workdayId');
    }
    if (localStorage.getItem('UserRoles')) {
      this.userRole = localStorage.getItem('UserRoles');
    }
    if (localStorage.getItem('UserName')) {
      this.userName = localStorage.getItem('UserName');
    }
    this.subscription$ = this.stateService.getNamc().subscribe((observable) => {
      this.initializeData();
    });
    // this.count = [
    //   {
    //     "count": "0.000000",
    //     "lineoff_date": "2025-02-24",
    //     "container_renban": "E2363",
    //     "apccapacity": 5,
    //     "sequence": 3,
    //     "count_pieces": "0.000000",
    //     "module_number": "A205 ",
    //     "countdate": "2025-03-04",
    //     "module_seq": 279117,
    //     "countString": "2025-03-04 E2363-A205 0.000000"
    //   },
    //   {
    //     "count": "4.000000",
    //     "lineoff_date": "2025-02-20",
    //     "container_renban": "E2355",
    //     "apccapacity": 5,
    //     "sequence": 1,
    //     "count_pieces": "4.000000",
    //     "module_number": "A210 ",
    //     "countdate": "2025-02-20",
    //     "module_seq": 278898,
    //     "countString": "2025-02-20 E2355-A210 4.000000"
    //   }

    // ];

    this.columnDefPartNo = [
      {
        headerName: 'Kanban', headerClass: 'my-custom-header-class', flex: 0.7, field: 'kanban',
        cellStyle: {
          'font-size': '10px'
        },
        sortable: true, suppressMovable: true,
      },
      {
        headerName: 'Part No', headerClass: 'my-custom-header-class',
        field: 'item_id',
        sortable: true,
        flex: 0.9,
        // tooltipField: 'item_id',
        suppressMovable: true,
        cellRenderer: (invNum) =>
          `<a class="hovereffect" style="cursor: pointer;" title="${invNum.value}">${invNum.value}</a>`,
      },
      {
        headerName: 'Part Description', headerClass: 'my-custom-header-class',
        field: 'part_description',
        sortable: true,
        flex: 1,
        cellStyle: {
          // 'padding-left': '12px',
          'line-height': '20px',
          // 'padding-top': '5px',
          'white-space': 'normal', // Ensures text wraps within the cell
          'word-wrap': 'break-word', // Breaks long words to fit within the cell
        },
        suppressMovable: true,
        tooltipField: 'part_description',
        // cellRenderer: (invNum) => `<a class="hovereffect" style="cursor: pointer;" >${invNum.value}</a>`,
      },
    ];
    this.columnDefManualAdj = [
      {
        headerName: 'Prod Wk', headerClass: 'my-custom-header-class',
        field: 'prodweek',
        flex: 0.8,
        floatingFilter: false,
        tooltipField: 'prodweek',
        headerTooltip: 'Prod Week(yyyyww)',
        cellStyle: {
          'padding-left': '12px',
          'line-height': '20px',
          'padding-top': '5px',
        },
        suppressMovable: true,
      },
      {
        headerName: 'M Adj', headerClass: 'my-custom-header-class',
        field: 'man_adj_per_week',
        flex: 0.6,
        floatingFilter: false,
        tooltipField: 'man_adj_per_week',
        sortable: true,
        cellStyle: {
          'padding-left': '12px',
          'line-height': '20px',
          'padding-top': '5px',
        },
        suppressMovable: true,
      },
      {
        headerName: 'Sys Adj', headerClass: 'my-custom-header-class',
        field: 'sys_adj_per_week',
        flex: 0.6,
        floatingFilter: false,
        tooltipField: 'sys_adj_per_week',
        cellStyle: {
          'padding-left': '12px',
          'line-height': '20px',
          'padding-top': '5px',
        },
        suppressMovable: true,
      },
      {
        headerName: 'Total', headerClass: 'my-custom-header-class',
        field: 'total_adj_qty_per_week',
        flex: 0.6,
        floatingFilter: false,
        tooltipField: 'total_adj_qty_per_week',
        cellStyle: {
          'padding-left': '12px',
          'line-height': '20px',
          'padding-top': '5px',
        },
        suppressMovable: true,
      },
    ];

    this.columnDefAction = [
      {
        headerName: 'Date', headerClass: 'my-custom-header-class',
        field: 'action_datetime',
        floatingFilter: false,
        sortable: true,
        // sort: 'desc', // Default sorting in descending order
        // tooltipField: 'action_datetime',
        flex: 0.7,
        cellStyle: {
          'padding-left': '12px',
          'line-height': '20px',
          'padding-top': '5px',
          'white-space': 'normal', // Ensures text wraps within the cell
          'word-wrap': 'break-word', // Breaks long words to fit within the cell
        },
        suppressMovable: true,
      },
      {
        headerName: 'Comment/Action', headerClass: 'my-custom-header-class',
        field: 'action_message',
        // tooltipField: 'action_message',
        sortable: true,
        flex: 1,
        floatingFilter: false,
        cellStyle: {
          'font-size': '10px',
          // 'padding-left': '12px',
          'line-height': '20px',
          // 'padding-top': '5px',
          'white-space': 'normal', // Ensures text wraps within the cell
          'word-wrap': 'break-word', // Breaks long words to fit within the cell
        },
        suppressMovable: true,
        autoHeight: true, // Automatically adjusts the row height
        cellRenderer: (params) => {
          return `<div style="white-space: normal; word-wrap: break-word; padding-left: 12px; line-height: 20px; padding-top: 5px;">${params.value}</div>`;
        },
      },
    ];

    // Create the chart
    // AgChart.create(this.chartOptions);
  }
  stockingToRange = []
  onStockingDtFromChange() {
    // if (this.stockDtFrom) {  
    //console.log('Pra1 :: before this.UsageVersusReceipt',this.UsageVersusReceipt);    
    let endIndex = null;
    const startIndex = this.UsageVersusReceipt.findIndex((item: any) => item.stocking_date === this.stockDtFrom?.stocking_date && item.container_renban === this.stockDtFrom.container_renban);
    this.stockingToRange = this.UsageVersusReceipt.slice(startIndex);
    setTimeout(() => {
      if (this.stockDtTo) {
        this.stockDtTo = {
          ...this.stockDtTo
        }
        endIndex = this.UsageVersusReceipt.findIndex((item: any) => item.stocking_date === this.stockDtTo?.stocking_date && item.container_renban === this.stockDtTo.container_renban);
      } else {
        this.stockDtToHold = {};
      }
      (endIndex && startIndex < endIndex) ? this.graph(this.UsageVersusReceipt.slice(startIndex, endIndex + 1)) : this.graph(this.stockingToRange);
      //console.log('Pra2 :: after this.UsageVersusReceipt',this.UsageVersusReceipt);
      this.stockDtFromHold = { ...this.stockDtFrom };
    }, 100);
    //console.log('Pra4 :: onStockingDtFromChange triggered this.stockDtFromHold', this.stockDtFromHold);
    // if (selectedIndex !== -1) {
    //   // this.stockingToRange = this.UsageVersusReceipt.slice(selectedIndex + 1);
    //   this.graph(this.UsageVersusReceipt.slice(selectedIndex + 1));
    // } else {
    //   this.stockingToRange = [];
    // }
    // this.stockDtTo = null;
    // }
  }
  //give a function where filtering the data based on the selected stocking date from and to only I need new array

  onStockingDtToChange() {
    let startIndex = 0;
    if (this.stockDtFrom)
      startIndex = this.UsageVersusReceipt.findIndex((item: any) => item.stocking_date === this.stockDtFrom?.stocking_date && item.container_renban === this.stockDtFrom.container_renban);
    const endIndex = this.UsageVersusReceipt.findIndex((item: any) => item.stocking_date === this.stockDtTo?.stocking_date && item.container_renban === this.stockDtTo.container_renban);
    if (startIndex < endIndex) {
      this.graph(this.UsageVersusReceipt.slice(startIndex, endIndex + 1));
    } else {
      this.warningMessage = 'Selected Stocking DT From should be less then Stocking DT To';
    }


    this.stockDtToHold = { ...this.stockDtTo };
    //console.log('Pra4 :: onStockingDtToChange triggered this.stockDtToHold', this.stockDtToHold);
    // let filteredStockingRange = [];
    // if (this.stockDtFrom && ) {
    //   const fromIndex = this.UsageVersusReceipt.findIndex(item => item.stocking_date === this.stockDtFrom.stocking_date);
    //   const toIndex = this.UsageVersusReceipt.findIndex(item => item.stocking_date === this.stockDtTo.stocking_date);
    //   if (fromIndex !== -1 && toIndex !== -1 && fromIndex < toIndex) {
    //     const resultRange = this.UsageVersusReceipt.slice(fromIndex, toIndex + 1);
    //     filteredStockingRange = resultRange;
    //   } else {
    //     filteredStockingRange = [];
    //   }
    //   this.graph(filteredStockingRange);
    // }
  }

  // this.selectedCount = data.value;
  onCountChange(data: any) {
    // const selectedItem = this.count.find((item) => item.countString === this.selectedCount);
    // if (selectedItem) {
    this.renban = this.selectedCount?.container_renban;
    // this.countDate = this.selectedCount.countdate;
    // }
  }

  onDockChange() {
    this.onResetDock();
    // this.partNoList = this.rowdata.filter((x) => x.dock === this.selectedDock.dock);
    // this.partNoList = this.partNoList.sort((a, b) => a.kanban.localeCompare(b.kanban));
    // this.kanbanList = this.partNoList;

    this.partNoList = this.row_clear_data.filter((x) => x.dock === this.selectedDock.dock);
    this.partNoList = this.partNoList.sort((a, b) => a.kanban.localeCompare(b.kanban));
    this.kanbanList = this.partNoList;

    this.selectedKanban = this.selectedPartNo = this.selectedSpecialist = null;
    // append employess in to list
    let myemployeeList = [];
    this.rowdata.filter((x) => x.dock === this.selectedDock.dock).forEach((element) => {
      let alradyExist = myemployeeList.findIndex((x) => x.employee == element.employee);
      if (alradyExist === -1) {
        myemployeeList.push(element);
      }
    });
    this.kanbanList = this.partNoList = this.partNoList.sort((a, b) => a.dock.localeCompare(b.dock));

    myemployeeList.sort((a, b) => a.employee - b.employee);
    this.specialistList = myemployeeList;
    this.partSelect = this.kanbanselect = false;
    this.partnorowdata = [];
    this.defaultService.setDockCode(JSON.stringify([{ dock: this.selectedDock.dock }]));
  }

  assignDefaultDock() {
    try {
      if (this.dockList?.length > 0) {
        const defaultdockArray: any[] = JSON.parse(this.defaultService.getCurrentDockCode());
        if (Array.isArray(defaultdockArray)) {
          const validDocks = new Set(defaultdockArray.map(item => item.dock));
          this.selectedDock = this.dockList.find(item => validDocks.has(item.dock));
          if (this.selectedDock) {
            return true;
          }
        }
      }
      return false;
    } catch (error) {
      console.log('Error in assigning default dock', error);
      return false;
    }
  }
  partSelect = false;
  kanbanselect = false;
  onKanbanChange() {
    this.removeMessage();
    this.partSelect = true;
    this.kanbanselect = false;
    this.selectedPartNo = this.selectedKanban;
    this.partnorowdata = [];
    this.partnorowdata.push(this.selectedPartNo);
    this.selectedCount = null;
    this.defaultcallGraphAPI();
  }
  onPartNoChange() {
    this.removeMessage();
    this.partSelect = false;
    this.kanbanselect = true;
    this.selectedKanban = this.selectedPartNo;
    this.partnorowdata = [];
    this.partnorowdata.push(this.selectedPartNo);
    this.selectedCount = null;
    this.defaultcallGraphAPI();
  }
  specialistChange() {
    this.kanbanList = this.partNoList = this.rowdata.filter((x) => x.employee === this.selectedSpecialist.employee);
  }
  onResetGraph(noresetHold = true) {
    this.stockingToRange = [];
    this.stockDtFrom = null;
    this.stockDtTo = null;
    if (noresetHold) {
      this.stockDtFromHold = {};
      this.stockDtToHold = {};
    }
    this.graph(this.UsageVersusReceipt);
  }
  onResetDropDown() {
    this.stockingToRange = [];
    this.stockDtFrom = null;
    this.stockDtTo = null;
    this.stockDtFromHold = {};
    this.stockDtToHold = {};
    this.partSelect = this.kanbanselect = false;
    this.kanbanList = [];
    this.partNoList = [];
    this.specialistList = [];
    this.partnorowdata = [];
    this.manualAdjGrid = [];
    this.actionrowdata = [];
    this.chartData = [];
    this.selectedAction = null;
    this.selectedKanban = this.selectedPartNo = this.selectedSpecialist = this.selectedDock = null;
    this.chartTitle =
      this.countDate =
      this.countCR =
      this.renban =
      this.count =
      this.selectedCount =
      this.chartResponse =
      '';
    if (this.chartInstance != null) {
      this.chartInstance.destroy();
    }
    this.removeMessage();
    this.isExpendChart = false;
    this.selectedchart = { chart_name: 'by number of lots', id: 1 };
    this.resetChart();
  }
  onResetDock() {
    this.stockingToRange = [];
    this.stockDtFrom = null;
    this.stockDtTo = null;
    this.stockDtFromHold = {};
    this.stockDtToHold = {};
    this.partSelect = this.kanbanselect = false;
    this.kanbanList = [];
    this.partNoList = [];
    this.specialistList = [];
    this.partnorowdata = [];
    this.manualAdjGrid = [];
    this.actionrowdata = [];
    this.chartData = [];
    this.selectedAction = null;
    this.selectedKanban = this.selectedPartNo = this.selectedSpecialist = null;
    this.chartTitle =
      this.countDate =
      this.countCR =
      this.renban =
      this.count =
      this.selectedCount =
      this.chartResponse =
      '';
    if (this.chartInstance != null) {
      this.chartInstance.destroy();
    }
    this.removeMessage();
    this.isExpendChart = false;
    this.selectedchart = { chart_name: 'by number of lots', id: 1 };
    this.resetChart();
  }
  kanbanNumber = '';
  onRowClicked(event: any) {
    this.partNo = event.data.item_id;
    this.kanbanNumber = event.data.kanban;
    this.getChartData(this.generateGraphReqData(''));
    this.getCount();
    this.getCommentsAction();
    this.selectedAction = null;
  }

  set() {
    // this.renban = this.selectedCount.container_renban;
    // this.countDate = this.selectedCount.countdate;
    const formattedDate = this.selectedCount.countdate.replace(/-/g, '');
    this.countCR = `${formattedDate}${this.renban}_${this.selectedCount.sequence}`;

    // Store selected count for retention in Stocking DT From
    if (this.selectedCount) {
      const dateParts = this.selectedCount.countdate.split('/');
      const dateFormatted = `${dateParts[2]}${dateParts[0].padStart(2, '0')}${dateParts[1].padStart(2, '0')}`;
      const stockingDate = `${dateFormatted} ${this.selectedCount.sequence} ${this.selectedCount.container_renban}`;
      this.stockDtFromHold = { stocking_date: stockingDate };
    }
    

    this.getChartData(this.generateGraphReqData(this.countCR)); // Call the search function to fetch data
  }

  onGridReady(params) {
    this.gridApi = params?.api;
  }

  // checked
  removeMessage() {
    this.resetWorning();
    this.successMessage = '';
    this.selectedAction = '';
  }
  resetWorning() {
    this.warningMessage = '';
  }

  // Function to handle the action selection
  onActionSelect(action: any) {
    this.selectedAction = action;

    // Check which action was selected and handle accordingly
    switch (action.action_name) {
      case 'Complete':
        this.performCompleteAction();
        break;
      case 'Add Comment':
        this.performAddComment();
        break;
      case 'Add to "To Be Counted"':
        //this.showModal(); // Show modal for this option

        this.performToBeCountedList();
        break;
      case 'Raise Manual Order':
        this.performRaiseManualOrder();
        break;
      case 'Raise Tap Request':
        this.performRaiseTapRequest();
        break;
      case 'Raise Air Order':
        this.performRaiseAirOrder();
        break;
      case 'Parts Information/Procurement':
        this.procurement();
        break;
      default:
        break;
    }
  }

  // Functions for the selected actions
  performCompleteAction() {
    this.selectedAction = '';
    this.completeApiCall();
    // this.successMessage = 'Parts completed successfully';
    // Add logic for the 'Complete' action
  }

  performAddComment() {
    this.addComment();

    // Add logic for the 'Add Comment' action
  }

  performToBeCountedList() {
    //checkcondition to be add ed or already present part in list
    this.removeMessage();
    this.callToBeCountedAPI();
    this.spinner.show();
    // this.successMessage = "Parts added successfully to the  'to be counted list'!";
  }
  // {"partNo":"113612501000","dock":{"item_id":"904802503700","dock":"5A","order_lot":500,"kanban":"5282","part_description":"GROMMET",
  // "eff_start":"2023-01-01T00:00:00.000Z","eff_stop":"2999-12-31T00:00:00.000Z","prod_start_date":"2023-01-01T00:00:00.000Z","prod_date":"2999-12-31T00:00:00.000Z",
  // "employee":"CM"},
  // "kanban":{"item_id":"113612501000","dock":"5A","order_lot":200,"kanban":"5000","part_description":"COVER, FLYWHEEL HOUSING UNDER",
  // "eff_start":"2023-01-01T00:00:00.000Z","eff_stop":"2999-12-31T00:00:00.000Z","prod_start_date":"2023-01-01T00:00:00.000Z","prod_date":"2999-12-31T00:00:00.000Z",
  // "employee":"HM"}}
  setLocalstorageValue() {
    let data = {
      dock: this.selectedDock,
      // kanban: this.selectedKanban
      kanban: this.kanbanList.find(a => a.kanban === this.kanbanNumber && a.dock === this.selectedDock?.dock) ?? null
    }
    localStorage.setItem('uvrFatch', JSON.stringify(data));
  }
  performRaiseManualOrder() {
    // this.openManualOrderDialog();
    this.dataService.sendFilteredData({
      partNo: this.partNo,
      dock: this.selectedDock.dock,
    });
    this.router.navigate(['ordering/orderforecast']);
  }
  procurement() {
    // this.openManualOrderDialog();

    this.dataService.sendFilteredData({
      partNo: this.partNo,
      dock: this.selectedDock.dock,
    });
    this.router.navigate(['inventory/Procurement']);
  }
  performRaiseTapRequest() {
    // this.openTapRequestDialog();
    this.moveToContainerTap();
  }

  moveToContainerTap() {
    localStorage.setItem('FromDevan', 'true');
    this.dataService.sendFilteredData({
      forEdit: false,
      data: null,
      part: this.partNo,
      dock: this.selectedDock.dock,
      // kanban: this.kanbanNumber,
      kanban: this.selectedKanban?.kanban ? this.selectedKanban.kanban : this.kanbanNumber
    });
    this.router.navigate(['inventory/containertap']);
  }
  performRaiseAirOrder() {
    this.riseAirOrder();
  }

  // Modal related functions
  addComment() {
    //this.isModalVisible = true;
    localStorage.setItem('popupname', 'add');
    this.openAddCommentDialog();
  }

  openRecalculateDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.width = '390px';
    dialogConfig.data = {
      partNo: this.partNo,
      mode: 'recalculate',
    };

    const dialogRef = this.dialog.open(UvrActionDialogComponent, dialogConfig);
    const editGetResponse = dialogRef.componentInstance.addRecalculateEventEmitter.subscribe((res) => {
      // this.successMessage = 'Recalulated Succesfully';

      this.spinner.show();

      const dataTosend = {
        business_entity: this.namcValue,
        workid: this.user,
        user_role: this.userRole,
        NAMC: this.namcName,
        userid: this.userName,
        batch_name: `osp-usagevsreceipt-calculation-batch`,
        dock: this.selectedDock?.dock,
        part_number: this.partNo,
        current_date: this.chartData[0]?.plan_stocking_date.substring(0, 10),
      };
      this.bulkadjustmentService.calculation(dataTosend).subscribe(
        (success) => {
          if (success.body.status) {
            this.successMessage =
              'UvR batch started successfully for your request, please check the status in the batch job status screen.';
            // console.log('osp-usagevsreceipt-calculation-batch  batch started successfully for your request');
          }
          this.spinner.hide();
        },
        (err) => {
          this.spinner.hide();
          this.successMessage = '';
          this.warningMessage = `${warningMessage.errorLLPshopfloordevannigBatch}.`;

          window.scroll(0, 0);
        }
      );
    });
  }

  openAddCommentDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.width = '550px';
    dialogConfig.height = '280px';
    dialogConfig.data = {
      // comment: this.comment,
      mode: 'addComment',
    };

    const dialogRef = this.dialog.open(UvrActionDialogComponent, dialogConfig);
    const editGetResponse = dialogRef.componentInstance.addCommentEventEmitter.subscribe((res) => {
      // this.successMessage = 'Comment Added Successfully';

      this.removeMessage();
      // if (res === 'cancel') {
      //   return;
      // }
      // if (res === 'save') {
      //this.spinner.show();
      // this.successMessage = "Comment Added Succesfully";
      var data = {
        offset: 0,
        limit: 1200,
        business_entity: this.namcValue,
        workid: this.user,
        user_role: this.userRole,
        part_no: this.partNo,
        dock: this.selectedDock?.dock,
        comment: res.comment.trim(),
        created_userid: this.userName,
        updated_userid: this.userName,
      };

      this.uvrService.addComment(data).subscribe({
        error: (error) => {
          this.spinner.hide();
          this.warningMessage = `Try again! Not able to call comment api. Please connect to support team | ${error}`;
        },
        next: (response) => {
          this.spinner.hide();

          if (typeof response.body === 'string') {
            if (response.body.startsWith("Can't")) {
              // Handle the case when response.body starts with "Can't"
              this.warningMessage = response.body;
            } else {
              this.successMessage = 'Part comment added successfully.';
              this.getCommentsAction(); // Refresh comments and actions after completion
            }
          } else if (Array.isArray(response.body)) {
            this.successMessage = 'Part comment added successfully.';
            this.getCommentsAction();
          } else {
            this.spinner.hide();
            this.warningMessage = `Try again! Not able to comment. Please connect to support team| ${response.error.message}`;
          }

          window.scroll(0, 0);
        },
        complete: () => {
          this.spinner.hide();
          this.selectedAction = '';
        },
      });
      // }
    });

    dialogRef.afterClosed().subscribe((res) => {
      editGetResponse.unsubscribe();
      this.selectedAction = '';
    });
  }

  //for MAnual order
  openManualOrderDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.width = '550px';
    dialogConfig.height = '315px';
    dialogConfig.data = {
      mode: 'addManualOrder',
    };

    const dialogRef = this.dialog.open(UvrActionDialogComponent, dialogConfig);
    const editGetResponse = dialogRef.componentInstance.addManualOrderEventEmitter.subscribe((res) => {
      // this.successMessage = 'Saved Succesfully';
      // console.log('Manual Order response', res);

      var data = {
        business_entity: this.namcValue,
        workid: this.user,
        user_role: this.userRole,
        userid: this.userName,
        part_no: this.partNo,
        dock: this.selectedDock?.dock,
        part_desc: this.selectedPartNo.part_description,
        kanban: this.selectedPartNo.kanban,
        supplier_code: this.supplier,
        request_type: 'MO',
        request_qty: res.qty,
        in_pieces: res.order_type === 'Lots' ? 'N' : 'Y',
        orderLot: this.selectedPartNo.order_lot,
        // date_by_when: "2025-04-23"
      };

      this.uvrService.raiseUpdateManOdrTapReq(data).subscribe({
        error: (error) => {
          this.spinner.hide();
          this.warningMessage = 'Try again! Not able to call manual order api. Please connect to support team';
        },
        next: (response) => {
          this.spinner.hide();

          if (response.body) {
            this.successMessage = 'Raised manual order successfully.';
            // this.getCommentsAction();

            this.actionrowdata = response.body?.data?.partActions;
          } else {
            this.spinner.hide();
            this.warningMessage = 'Try again! Not able to call manual order api. Please connect to support team';
          }

          window.scroll(0, 0);
        },
        complete: () => {
          this.spinner.hide();
          this.selectedAction = '';
        },
      });
      // }
    });

    dialogRef.afterClosed().subscribe((res) => {
      editGetResponse.unsubscribe();
      this.selectedAction = '';
    });
  }

  // for Tap request
  openTapRequestDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.width = '550px';
    dialogConfig.height = '315px';
    dialogConfig.data = {
      text1: this.text1,
      text2: this.text2,
      textDate: this.textDate,
      mode: 'addTapRequest',
    };

    const dialogRef = this.dialog.open(UvrActionDialogComponent, dialogConfig);
    const editGetResponse = dialogRef.componentInstance.addTapRequestEventEmitter.subscribe((res) => {

      var data = {
        business_entity: this.namcValue,
        workid: this.user,
        user_role: this.userRole,
        userid: this.userName,
        part_no: this.partNo,
        dock: this.selectedDock?.dock,
        part_desc: this.selectedPartNo.part_description,
        kanban: this.selectedPartNo.kanban,
        supplier_code: this.supplier,
        request_type: 'CT',
        request_qty: res.qty,
        in_pieces: res.order_type === 'Lots' ? 'N' : 'Y',
        orderLot: this.selectedPartNo.order_lot,
        date_by_when: res.date_by_when,
      };

      this.uvrService.raiseUpdateManOdrTapReq(data).subscribe({
        error: (error) => {
          this.spinner.hide();
          this.warningMessage = 'Try again! Not able to call tap api. Please connect to support team';
        },
        next: (response) => {
          this.spinner.hide();

          if (response.body) {
            this.successMessage = 'Part requested successfully.';
            this.actionrowdata = response.body?.data?.partActions;
            // this.getCommentsAction();
          } else {
            this.spinner.hide();
            this.warningMessage = 'Try again! Not able to call tap api. Please connect to support team';
          }

          window.scroll(0, 0);
        },
        complete: () => {
          this.spinner.hide();
          this.selectedAction = null;
        },
      });
    });
    dialogRef.afterClosed().subscribe((res) => {
      editGetResponse.unsubscribe();
      this.selectedAction = null;
    });
  }
  riseAirOrder() {
    this.setLocalstorageValue();
    this.dataService.sendFilteredData({
      forEdit: false,
      data: null,
      forAddPart: this.partNo,
      dock: this.selectedDock.dock,
    });
    this.router.navigate(['add-edit-air-order']);
  }

  onSearch() {
    this.selectedAction = '';
    this.removeMessage();
    if (this.selectedDock == null || this.selectedDock === undefined) {
      this.warningMessage = 'Please select dock.';
      return false;
    }
    if (this.selectedPartNo != null || this.selectedKanban != null) {
      this.defaultcallGraphAPI();
      return false;
    }
    if (this.selectedSpecialist != null) {
      this.partnorowdata = this.partNoList.filter(x => x.employee == this.selectedSpecialist.employee && x.dock == this.selectedDock.dock);
      return false;
    }
    this.partnorowdata = this.rowdata.filter((x) => x.dock == this.selectedDock.dock);
    this.partnorowdata = this.partnorowdata.sort((a, b) => a.kanban.localeCompare(b.kanban));
    // this.defaultcallGraphAPI();
  }
  defaultcallGraphAPI() {
    if (this.partnorowdata.length == 1) {
      this.partNo = this.partnorowdata[0].item_id;
      this.getChartData(this.generateGraphReqData(''));
      this.getCount();
      this.getCommentsAction();
    }
  }
  chartData = [];
  chartTitle = '';
  chartResponse = null;

  noChartData() {
    this.spinner.hide();
    this.warningMessage = `No UvR data found for this part.`; //'No Devan plan found for this dock. Please generate devan plan for generating UVR.';
    this.chartData = [];
    this.chartTitle = '';
    if (this.chartInstance != null) {
      this.chartInstance.destroy();
    }
  }
  // chartResponse = null;
  getChartData(data) {
    this.warningMessage=''
    this.spinner.show();
    this.uvrService.getGraph(data).subscribe({
      error: (error) => {
        logErrors(error);
        this.spinner.hide();
        this.warningMessage = `Try again! Error in get Graph Details | ${error.error.message}`;
        this.chartData = [];
        this.chartTitle = '';
        if (this.chartInstance != null) {
          this.chartInstance.destroy();
        }
      },
      next: (res) => {
        if (res.body) {
          this.chartResponse = res.body[0];
        }
      },
      complete: () => {
        if (this.chartResponse.uvrData) {
          this.chartData = this.chartResponse.uvrData;
          let chartTitle = '';
          if (this.chartResponse.part_no) {
            chartTitle += `Part No: ${this.chartResponse.part_no} `;
          }
          if (this.chartResponse.kanban) {
            chartTitle += `Kanban: ${this.chartResponse.kanban} `;
          }
          if (this.chartResponse.supplier) {
            chartTitle += `Supplier: ${this.chartResponse.supplier} `;
          }
          if (this.chartResponse.inventoryPolicy) {
            chartTitle += `Inventory Policy: ${this.chartResponse.inventoryPolicy} `;
          }
          if (this.chartResponse.groupName) {

            const uniqueGroupNames = Array.from(new Set(this.chartResponse.groupName));
            chartTitle += `\nPart Group: ${uniqueGroupNames.join(', ')} `;
          }
          if (this.chartResponse.apc) {
            // console.log('this.chartResponse.apc', this.chartResponse.apc);
            chartTitle += `Safety: ${this.chartResponse.apc} `;
          }
          if (this.chartResponse.orderLot) {
            const effStartDate = new Date(this.chartResponse?.eff_start);
            const effStopDate = new Date(this.chartResponse?.eff_stop);
            // const formattedEffStartDate = effStartDate.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '');
            // const formattedEffStopDate = effStopDate.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '');
            const formattedEffStartDate = effStartDate.toISOString().slice(0, 10).replace(/-/g, '');
            const formattedEffStopDate = effStopDate.toISOString().slice(0, 10).replace(/-/g, '');
            chartTitle += `Orderlot info: ${this.chartResponse.orderLot} (${formattedEffStartDate}-${formattedEffStopDate})`;
          }

          this.chartTitle = chartTitle;
          this.isStockingDateUpdate = false;
          this.UvrCalculation();
        } else {
          this.noChartData();
        }
        // this.generateChart();
        // this.spinner.hide();
        this.spinner.hide();
      },
    });
  }

  initializeData() {
    this.namcValue = localStorage.getItem('namcvalue');

    if (localStorage.getItem('workdayId')) {
      this.user = localStorage.getItem('workdayId');
    }
    if (localStorage.getItem('UserRoles')) {
      this.userRole = localStorage.getItem('UserRoles');
    }
    if (localStorage.getItem('namcName')) {
      this.namcName = localStorage.getItem('namcName');
    }
    this.loadDrop();
    this.onResetDropDown();
  }
  row_clear_data = [];
  loadDrop() {
    this.spinner.show();

    const lookupSubscriptions = [this.lookupService.getqpcforpart(), this.lookupService.getSupplier()];
    forkJoin(lookupSubscriptions).subscribe({
      next: (res) => {
        //if kanbanList, add ALL option
        this.kanbanList = [];
        this.dockList = [];
        this.specialistList = [];
        this.partNoList = [];
        if (!res[0].error) {
          if (res[0].body) {
            const tepm_cleaned = res[0].body.data.map(obj => {
              const { employee, eff_start, eff_stop, prod_start_date, prod_date, ...rest } = obj;
              return rest;
            });

            this.row_clear_data = Array.from(
              new Map(tepm_cleaned.map(o => [JSON.stringify(o), o])).values()
            );
            const cleaned = res[0].body.data.map(obj => {
              const { eff_start, eff_stop, prod_start_date, prod_date, ...rest } = obj;
              return rest;
            });
            this.rowdata = Array.from(
              new Map(cleaned.map(o => [JSON.stringify(o), o])).values()
            );
            let myList = [];
            this.rowdata.forEach((element) => {
              let alradyExist = myList.findIndex((x) => x.dock == element.dock);
              if (alradyExist === -1) {
                myList.push(element);
              }
            });
            this.dockList = myList.sort((a, b) => a.dock.localeCompare(b.dock));
          }
        } else {
          this.warningMessage = `Try after some time! Error in get dock, Part, Kanban, Specialist. |${res[0].error?.error?.message}`;
        }
        if (!res[1].error) {
          if (res[1].body) {
            this.supplier = res[1].body.data[0].customer_supp; // Assuming the first element contains the supplier data
          }
        } else {
          this.warningMessage = `Try after some time! Error in get dock, Part, Kanban, Specialist |${res[1].error?.error?.message}`;
        }
        if (this.assignDefaultDock()) {
          this.onDockChange();
        }
      },
      complete: () => {
        this.spinner.hide();
        const history = localStorage.getItem('uvrFatch');
        if (history != undefined && history != "undefined") {
          const data = JSON.parse(history);
          this.selectedDock = data.dock;
          this.selectedKanban = data.kanban;
          this.onKanbanChange();
        }
        localStorage.setItem('uvrFatch', undefined);
      },
    });
  }
  private chartInstance: AgChartInstance = null;
  title(value) {
    if (value !== undefined) {
      const regex = /Safety: \d+/;
      if (regex.test(this.chartTitle)) {
        this.chartTitle = this.chartTitle.replace(regex, `Safety: ${value}`);
      } else {
        console.error("Pattern 'Safety: \\d+' not found in chartTitle");
      }
    } else {
      console.error('val.apc is undefined or null');
    }
  }

  onChartChange() {
    this.onResetGraph(false);
    this.UvrCalculation();

    // this.generateChart();
  }
  isStockingDateUpdate = false;
  chartImage;
  async generateExcel() {
    // Get the canvas element for the chart
    const base64Image = await AgChart.getImageDataURL(this.chartInstance, {
      width: 1500,
      height: 600,
      fileFormat: 'image/png',
    });
    await this.chartService.generateExcel(this.UsageVersusReceipt, base64Image, this.selectedDock?.dock);
  }

  getCount() {
    // this.spinner.show();
    const data = {
      offset: 0,
      limit: 1200,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      part_no: this.partNo,
      dock: this.selectedDock?.dock,
    };
    this.manualAdjGrid = [];
    this.uvrService.count(data).subscribe({
      error: (error) => {
        this.spinner.hide();
        this.warningMessage = `Try again! Not able to get count details. Please connect to support team. |${error.error?.message}`;
      },

      next: (res) => {
        if (res.body) {
          // this.spinner.hide();
          this.count = res.body?.count;
          this.selectedCount = this.count.length > 0 ? this.count[0] : null;
          this.onCountChange(null);
          this.manualAdjGrid = res.body?.adjustment;
        } else {
          // this.spinner.hide();
          this.warningMessage = `Try again! Not able to get count details. Please connect to support team |${res.error?.message}`;
        }
      },
    });
  }

  getCommentsAction() {
    // this.spinner.show();
    const data = {
      offset: 0,
      limit: 1200,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      part_no: this.partNo,
      dock: this.selectedDock?.dock,
    };
    // this.manualAdjGrid = [];
    this.actionrowdata = [];
    this.uvrService.comments(data).subscribe({
      error: (error) => {
        this.spinner.hide();
        this.warningMessage = `Try again! Not able to get comments details. Please connect to support team |${error.error?.message}`;
      },
      next: (res) => {
        if (res.body) {
          // this.spinner.hide();
          // this.count = res.body?.count;
          this.actionrowdata = res.body;
        } else {
          // this.spinner.hide();
          this.warningMessage = `Try again! Not able to get comments details. Please connect to support team |${res.error?.message}`;
        }
      },
    });
  }
  generateGraphReqData(countCR: any) {
    return {
      offset: 0,
      limit: 12000,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      // "user_role": "OSP.ADMIN,OSP.USERS,OSPIPE.ADMIN",
      dock: this.selectedDock.dock,
      part_no: this.partNo,
      countCR: countCR,
    };
  }
  completeApiCall() {
    this.spinner.show();
    const data = {
      offset: 0,
      limit: 1200,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      part_no: this.partNo,
      dock: this.selectedDock?.dock,
      action_message: 'Completed',
      created_userid: this.userName,
      updated_userid: this.userName,
    };
    this.manualAdjGrid = [];
    this.uvrService.complete(data).subscribe({
      error: (error) => {
        this.spinner.hide();
        this.warningMessage = `Try again! Not able to call complete api. Please connect to support team |${error.error?.message}`;
      },
      next: (res) => {
        if (res.body) {
          this.spinner.hide();
          this.successMessage = 'Part completed successfully.';
          this.actionrowdata = res.body;
          // ?.data?.partActions;
        } else {
          this.spinner.hide();
          this.warningMessage = `Try again! Not able to get count details. Please connect to support team |${res.error?.message}`;
        }
      },
      complete: () => {
        this.spinner.hide();
        this.selectedAction = null;
      },
    });
  }

  // getPipeToken() {
  //   const dataP = {
  //     business_entity: this.namcValue,
  //     workid: this.user,
  //     user_role: this.userRole,
  //   };
  //   this.pipeLookupService.getPieToken(dataP).subscribe({
  //     error: (error) => {
  //       this.spinner.hide();
  //       this.warningMessage = 'Try again! Not able to call PIE api. Please connect to support team';
  //     },
  //     next: (res) => {
  //       console.log('res token---------', res);
  //       const pieToken = {
  //         token: res.body.auth_token.access_token,
  //         start_date:"2025-03-22",
  //         stop_date:"2025-03-30"
  //       };
  //       this.callPieAdrAPI(pieToken); // Call the PIE ADR API with the token
  //       if (!pieToken) {
  //         this.spinner.hide();
  //         this.warningMessage = 'Try again! Not able to get PIE token. Please connect to support team';
  //         return;
  //       }
  //       this.spinner.hide();
  //       return pieToken;
  //     },
  //   });
  // }

  callToBeCountedAPI() {
    const data = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      part_no: this.partNo,
      dock: this.selectedDock?.dock,
      // action_message: 'Count Requested',
      userid: this.userName,

      // manually_added: 'Y',
      part_desc: this.selectedPartNo.part_description,
      kanban: this.selectedPartNo.kanban,
      // boxtype: '(packageing_type)',
      // flowrack_address: '(store_address(ADR))',
      // flowrack_capacity: '(store it as 0,store_rack_capacity(adr api)',
      // lineside_address: '(delivery_address(ADR))',
    };

    this.uvrService.toBeCounted(data).subscribe({
      error: (error) => {
        this.spinner.hide();
        this.warningMessage = `Try again! Not able to call "to be counted" api. Please connect to support team |${error.error?.message}`;
        this.selectedAction = null;
        window.scroll(0, 0);
      },
      next: (res) => {
        if (res.body) {
          this.spinner.hide();
          if (res.body.msg.includes('Error')) {
            this.warningMessage = res.body.msg;
          } else {
            this.successMessage = res.body.msg;
          }
          window.scroll(0, 0);
          // 'Part added to "to be counted" list successfully.';
          this.getCommentsAction(); // Refresh comments and actions after completion
        } else {
          this.spinner.hide();
          this.warningMessage = `Try again! Not able to get count details. Please connect to support team |${res.error?.message}`;
          window.scroll(0, 0);
        }
      },
      complete: () => {
        this.spinner.hide();
        this.selectedAction = null;
      },
    });
  }
//
  /**
    * Performs the Uvr calculation by filtering the chart data based on the test container.
    * The function iterates through the `chartData`, checking the `testContainer1` value.
    * If `testContainer1` is empty or matches the `container_renban` of the current item,
    * it starts adding items to a new array. The filtered results are then assigned back to 
    * `chartData`, and the `putPartCount` method is called to update part counts.
    */
  UvrCalculation() {
    this.spinner.show();
    // console.log('uvrCalculation', this.chartData);

    const newArray = [];
    let chartStarted = false;
    this.chartData.forEach((item) => {
      let testContainer1 = this.chartResponse?.testContainer1 || '';

      if (testContainer1 == '' || testContainer1 == null) {
        chartStarted = true;
      } else if (testContainer1 == item.container_renban) {
        chartStarted = true;
      }

      if (chartStarted) {
        newArray.push(item);
      }
    });

    this.chartData = newArray;
    this.putPartCount();
    // console.log('uvrCalculation newArray', this.chartData, newArray);
    this.spinner.hide();
  }

 
  /**
   * Updates the part count for each item in the chart data based on the provided counts.
   * This function iterates through the `chartData` array and for each item, it checks
   * against the `count` array to find matching entries based on date and sequence.
   * If a match is found, it updates the count values in the chart data.
   * 
   * The function also manages a loading spinner to indicate processing status.
   * 
   * @returns {void} This function does not return a value.
   */
  putPartCount() {
    this.spinner.show();
    // console.log('putPartCount', this.chartData);
    this.chartData.forEach((val) => {
      val.countInBoxes = null;
      val.countInPieces = null;
      var stoploop = false; // Flag to control the loop exit
      for (let i = 0; i < this.count?.length && !stoploop; i++) {
        const count = this.count[i];
        // Rest of the code inside the loop
        // const countDate = new Date(count.countdate).toISOString().substring(0, 10); // Convert countdate to ISO string format
        // const lineOffDate = new Date(val.plan_stocking_date).toISOString().substring(0, 10); // Convert plan_stocking_date to ISO string format
        const countDate = `${new Date(count.countdate).getFullYear()}-${new Date(count.countdate).getMonth()+1}-${new Date(count.countdate).getDate()}`;
        const lineOffDate = `${new Date(val.plan_stocking_date).getFullYear()}-${new Date(val.plan_stocking_date).getMonth()+1}-${new Date(val.plan_stocking_date).getDate()}`;

        if (count.sequence != null && count.sequence > 0) {
          if (
            countDate === lineOffDate &&
            val.container_renban === count.container_renban &&
            val.sequence === count.sequence
          ) {
            // If the dates match, assign the count values
            val.countDate = count.countdate + count.container_renban;
            val.countInPieces = count.count_pieces;
            val.countInBoxes = count.count;
            stoploop = true; // Stop the loop if a match is found
          } 
          // else if (countDate === lineOffDate && val.container_renban === count.container_renban) {
          //   val.countDate = count.countdate + count.container_renban;
          //   val.countInBoxes = count.count;
          //   stoploop = true; // Stop the loop if a match is found
          // }
        }
      }
    });
    this.fillPartCount();
    this.spinner.hide();
  }

  /**
   * Fill the whole usageVersusReceipt List with the corresponding count value.
   *
   * @param usageVersusReceiptList
   */
  fillPartCount() {
    // console.log('fillPartCount', this.chartData);

    this.spinner.show();
    var usageVersusReceipt = null;
    var oldUsageVersusReceipt = null;

    // this.chartData.forEach((val) => {
    //   usageVersusReceipt = {...val};
    //   usageVersusReceipt.countDate = '';

    //   if (oldUsageVersusReceipt != null) {
    //     if (usageVersusReceipt.countInBoxes == null && oldUsageVersusReceipt.countInBoxes != null) {
    //       usageVersusReceipt.countDate = oldUsageVersusReceipt.countDate;
    //       usageVersusReceipt.countInBoxes = oldUsageVersusReceipt.countInBoxes;
    //       usageVersusReceipt.countInPieces = oldUsageVersusReceipt.countInPieces;
    //     } else if (usageVersusReceipt.countInBoxes == null) {
    //       usageVersusReceipt.countInBoxes = 0;
    //       usageVersusReceipt.countInPieces = 0;
    //     }
    //   } else if (usageVersusReceipt.countInBoxes == null) {
    //     usageVersusReceipt.countInBoxes = 0;
    //     usageVersusReceipt.countInPieces = 0;
    //   }

    //   oldUsageVersusReceipt = usageVersusReceipt;
    // });
    let updatedcountdata = null;
    // console.log(`Fill part count method ${this.chartData}`);
    this.chartData.forEach((val) => {
      // usageVersusReceipt = {...val};
      // usageVersusReceipt.countDate = '';
      
      if (updatedcountdata != null || val.countInBoxes != null) {
        if (val.countInBoxes != null) {
          updatedcountdata = val;
        }
          val.countDate = updatedcountdata.countDate;
          val.countInBoxes = updatedcountdata.countInBoxes;
          val.countInPieces = updatedcountdata.countInPieces;
        } else{
          val.countInBoxes = 0;
          val.countInPieces = 0;
          val.countDate = null;
        }
      // }
      //  else if (usageVersusReceipt.countInBoxes == null) {
      //   usageVersusReceipt.countInBoxes = 0;
      //   usageVersusReceipt.countInPieces = 0;
      // }

      // oldUsageVersusReceipt = usageVersusReceipt;
    });



    this.makeCumulativeWithCount();
    this.spinner.hide();
  }

  
  /**
    * Calculates cumulative values for usage versus receipt data.
    * This function processes the chart data to compute cumulative totals
    * for boxes and pieces, updating the respective properties in the data objects.
    * It also handles the carry-over quantity for specific conditions.
    * 
    * The function initializes cumulative counters and resets them based on
    * the count date. It updates the chart data with cumulative values and
    * manages the display of the chart based on the availability of data.
    * 
    * @returns {void} This function does not return a value.
    */
  makeCumulativeWithCount() {
    // console.log('makeCumulativeWithCount', this.chartData);
    this.spinner.show();

    var usageVersusReceiptData = new Array();
    var completeUsageVersusReceiptData = new Array();

    var usageVersusReceipt = null;

    let cumulativeInBoxes = 0;
    let cumulativeInPieces = 0;
    let cumulativeWithCountInBoxes = 0;
    let cumulativeWithCountInPieces = 0;

    var countDate = '';
    var oldCountDate = '';

    var chartStarted = false;

    this.chartData.forEach((val) => {
      usageVersusReceipt = val;

      countDate = usageVersusReceipt.countDate;

      // When passing a new count the cumulative value is put to zero again.
      if (countDate != null && countDate != oldCountDate) {
        cumulativeInBoxes = 0;
        cumulativeInPieces = 0;
      }

      /*
      1. 20 - count =100 = 120
      2. 34 - count = 200 = 234
      3. 45
      234 + 45 = 279
      */
      cumulativeInBoxes = cumulativeInBoxes + parseFloat(val.usage_v_receipt);
      // console.log('cumulativeInBoxes', cumulativeInBoxes,val.usage_v_receipt, val.container_renban, val.plan_stocking_date, val.uvr_pieces, val.countInBoxes, val.countInPieces);

      cumulativeInPieces = cumulativeInPieces + parseFloat(val.uvr_pieces);
      if (val.countInBoxes != null) {
        cumulativeWithCountInBoxes = cumulativeInBoxes + parseFloat(val.countInBoxes);
      }

      if (val.countInPieces != null) {
        cumulativeWithCountInPieces = cumulativeInPieces + parseFloat(val.countInPieces);
      }

      if (this.selectedchart.id == 2 || this.selectedchart.id == 3) {
        val.uvr = parseFloat(val.uvr_pieces);
        val.uvrCumul = cumulativeWithCountInPieces;
      } else {
        val.uvr = parseFloat(val.usage_v_receipt);
        val.uvrCumul = cumulativeWithCountInBoxes;
        val.uvrCumulPieces = cumulativeWithCountInPieces;
      }
      val.uvrCumulInBoxes = cumulativeWithCountInBoxes;
      val.uvrCumulInPieces = cumulativeWithCountInPieces;

      if (!chartStarted) {
        if (
          this.chartData[0].plan_stocking_date === val.plan_stocking_date &&
          this.chartData[0].container_renban === val.container_renban
        ) {
          chartStarted = true;
          usageVersusReceiptData.push(usageVersusReceipt);
        }
      } else {
        usageVersusReceiptData.push(usageVersusReceipt);
      }

      completeUsageVersusReceiptData.push(usageVersusReceipt);
      oldCountDate = countDate;

      if (val.container_renban == 'COVER') {
        var carryOver = parseFloat(val.usage_v_receipt);
        // carryOver = carryOver;

        this.carryOverQty = carryOver;
        this.CarryOverStockingDate = val.plan_stocking_date;
      }
    });

    this.UsageVersusReceipt = usageVersusReceiptData;
    this.UsageVersusReceiptComplete = completeUsageVersusReceiptData;

    if (this.UsageVersusReceipt == null || this.UsageVersusReceipt.length == 0) {
      // alert('1775');
      this.noChartData();
    } else {
      this.scaleChartData();
      this.spinner.hide();
    }

    // return usageVersusReceiptData;
  }
  carryOverQty: any;
  CarryOverStockingDate: any;
  UsageVersusReceipt: any = [];
  UsageVersusReceiptComplete: any = [];

  /**
    * Scales the chart data based on the selected chart type and updates the chart instance.
    * 
    * This method processes the `UsageVersusReceipt` data to calculate the usage versus receipt values,
    * cumulative values, maximum and minimum stock levels, and APC capacity. It handles different chart
    * types by applying specific calculations based on the selected chart ID. If all requirements are empty
    * for the selected chart type, a warning message is displayed, and the chart data is cleared.
    * 
    * @returns {void} This function does not return a value.
    */
  scaleChartData() {
    // console.log('scaleChartData', this.UsageVersusReceipt);
    this.spinner.show();
   
    var uvr = 0;
    var uvrCumul = 0;
    var apc = this.chartResponse?.apc;

    var orderLot = parseFloat(this.chartResponse?.orderLot);

    if (orderLot == null || orderLot == undefined) {
      orderLot = 0;
    }

    var isAllRequirementEmpty = true;

    var oldUvrInPieces = null;
    var oldUvrCumulInPieces = null;
    var maxStock = null;
    var oldMaxStock = null;
    var minStock = null;
    var oldMinStock = null;

    var oldApcCapacity = null;

    this.UsageVersusReceipt.forEach((val) => {
      var usageVersusReceipt = val;

      if (this.selectedchart.id == 2) {
        uvr = parseFloat(usageVersusReceipt.uvr_pieces);
        uvrCumul = parseFloat(usageVersusReceipt.uvrCumulInPieces);

        maxStock = parseFloat(usageVersusReceipt.max_pieces);
        minStock = parseFloat(usageVersusReceipt.min_pieces);

        if (apc != null) {
          usageVersusReceipt.apcCapacity = (this.chartResponse?.apc || 0) * (this.chartResponse?.orderLot || 0);
        }
      } else if (this.selectedchart.id == 3) {
        uvr = parseFloat(usageVersusReceipt.uvr_pieces);
        uvrCumul = parseFloat(usageVersusReceipt.uvrCumulInPieces);

        var req = parseFloat(usageVersusReceipt.uvr_by_day_req);

        if (req == 0) {
          // Solved mantis issue 0002833 - UAT: UvR in no days req when no req
          if (isAllRequirementEmpty) {
            maxStock = null;
            minStock = null;
            if (apc != null) {
              usageVersusReceipt.apcCapacity = parseFloat(this.chartResponse?.apc);
            }
          } else {
            uvr = parseFloat(oldUvrInPieces);
            uvrCumul = parseFloat(oldUvrCumulInPieces);

            uvr = parseFloat(uvr.toFixed(6));
            uvrCumul = parseFloat(uvrCumul.toFixed(6));

            maxStock = parseFloat(oldMaxStock);
            minStock = parseFloat(oldMinStock);

            if (apc != null) {
              usageVersusReceipt.apcCapacity = parseFloat(oldApcCapacity);
            }
          }
        } else {
          isAllRequirementEmpty = false;

          // divide by rqdb for that day
          uvr = parseFloat((uvr / req).toFixed(6));
          uvrCumul = parseFloat((uvrCumul / req).toFixed(6));

          if (usageVersusReceipt.max_pieces != null) {
            maxStock = parseFloat(usageVersusReceipt.max_pieces);
            maxStock = parseFloat((maxStock / req).toFixed(6));
          } else {
            maxStock = null;
          }
          if (usageVersusReceipt.min_pieces != null) {
            minStock = parseFloat(usageVersusReceipt.min_pieces);
            minStock = parseFloat((minStock / req).toFixed(6));
          } else {
            minStock = null;
          }

          if (apc != null) {
            usageVersusReceipt.apcCapacity = (apc / req) * orderLot;
          }
        }
      } else {
        uvr = parseFloat(usageVersusReceipt.usage_v_receipt);
        uvrCumul = parseFloat(usageVersusReceipt.uvrCumulInBoxes);

        maxStock = parseFloat(usageVersusReceipt.max);
        minStock = parseFloat(usageVersusReceipt.min);

        if (apc != null) {
          usageVersusReceipt.apcCapacity = apc;
        }
      }

      usageVersusReceipt.uvr = uvr;
      usageVersusReceipt.uvrCumul = uvrCumul;
      usageVersusReceipt.maxStock = maxStock;
      usageVersusReceipt.minStock = minStock;

      oldUvrInPieces = usageVersusReceipt.uvr_pieces;
      oldUvrCumulInPieces = usageVersusReceipt.uvrCumulInPieces;
      oldApcCapacity = usageVersusReceipt.apcCapacity;
      oldMaxStock = usageVersusReceipt.max;
      oldMinStock = usageVersusReceipt.min;
    });

    if (this.selectedchart.id == 3 && isAllRequirementEmpty) {
      this.warningMessage = 'All requirement for this part is empty for the whole UvR range.';
      this.chartData = [];
      this.chartTitle = '';
      if (this.chartInstance != null) {
        this.chartInstance.destroy();
      }
    }

    this.generateChartNew(); // Call the method to generate the chart with the updated data
    this.spinner.hide();
  }

  convertToYYYYMMDD(isoDateString: string): string {
    const date = new Date(isoDateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}${month}${day}`;
  }

  /**
    * Generates a new chart based on the UsageVersusReceipt data.
    * 
    * This method filters the UsageVersusReceipt array based on the starting point
    * defined in the chartResponse. It checks for the container_renban and stocking_datetime
    * to determine which items should be included in the new chart data.
    * 
    * If no items are found after filtering, it calls the noChartData method.
    * Finally, it invokes the graph method to render the chart with the filtered data.
    */
  generateChartNew() {
    // console.log('generateChartNew',this.UsageVersusReceipt);
    this.spinner.show();
    let chartStarted = false;
    let newArray = [];
    this.UsageVersusReceipt.forEach((item) => {
      let testContainer1 = this.chartResponse?.GraphStartingPoint?.container_renban || '';
      if (testContainer1 == '' || testContainer1 == null) {
        chartStarted = true;
      } else if (testContainer1 == item.container_renban) {
        chartStarted = true;
      }
      if (chartStarted) {
        newArray.push(item);
      }
    });
    if (newArray.length == 0) {
      this.UsageVersusReceipt.forEach((item) => {
        let startDate = this.convertToYYYYMMDD(this.chartResponse?.GraphStartingPoint?.stocking_datetime) || '';
        if (startDate == '' || startDate == null) {
          chartStarted = true;
        } else if (startDate <= this.convertToYYYYMMDD(item.plan_stocking_date)) {
          chartStarted = true;
        }
        if (chartStarted) {
          newArray.push(item);
        }
      });
    }
    this.UsageVersusReceipt = newArray;

    if (this.UsageVersusReceipt.length == 0) {
      // alert('1943');
      this.noChartData();
      return;
    }

    this.graph(this.UsageVersusReceipt);
    // UAT #617
    this.retainDropDownValuesFrom(this.UsageVersusReceipt);
    // END UAT #617
  }

  retainDropDownValuesFrom(usageVersusReceipt) {

    if (usageVersusReceipt && usageVersusReceipt.length > 0) {

      //console.log('Pra5 :: Inside retainDropDownValuesFrom function usageVersusReceipt', usageVersusReceipt);
      //console.log('Pra6 :: Inside retainDropDownValuesFrom function this.stockDtFromHold ', this.stockDtFromHold);

      if (this.stockDtFromHold && Object.keys(this.stockDtFromHold).length > 0) {
        const foundObject = usageVersusReceipt.find(item => item.stocking_date === this.stockDtFromHold.stocking_date);
        //console.log('Pra7 :: Inside retainDropDownValuesFrom function foundObject ', foundObject);

        if (foundObject && Object.keys(foundObject).length > 0) {
          setTimeout(() => {
            this.stockDtFrom = foundObject;
            this.onStockingDtFromChange();
            this.retainDropDownValuesTo(this.stockingToRange.length > 0 ? this.stockingToRange : this.UsageVersusReceipt);
          }, 100);
        }else{
          this.stockDtFromHold = {};
          this.retainDropDownValuesTo(this.stockingToRange.length > 0 ? this.stockingToRange : this.UsageVersusReceipt);
        }
      }else{
        this.retainDropDownValuesTo(this.stockingToRange.length > 0 ? this.stockingToRange : this.UsageVersusReceipt);
      }

    }

  }

  retainDropDownValuesTo(stockingToRange) {

    if (stockingToRange && stockingToRange.length > 0) {

      //console.log('Pra8 :: Inside retainDropDownValuesTo function stockingToRange', stockingToRange);
      //console.log('Pra9 :: Inside retainDropDownValuesTo function this.stockDtToHold ', this.stockDtToHold);

      if (this.stockDtToHold && Object.keys(this.stockDtToHold).length > 0) {
        const foundObject = stockingToRange.find(item => item.stocking_date === this.stockDtToHold.stocking_date);
        //console.log('Pra10 :: Inside retainDropDownValuesTo function foundObject ', foundObject);

        if (foundObject && Object.keys(foundObject).length > 0) {
          setTimeout(() => {
            this.stockDtTo = foundObject;
            this.onStockingDtToChange();
          }, 100);
        }else{
          this.stockDtToHold = {};
        }
      }
    }
  }

  removeaddedData(data) {
    let finalData = [];
    data.forEach((element: any, index: number) => {
      if (!element.hasOwnProperty('addtoexcel')) {
        finalData.push(element);
      }
    });
    return finalData;
  }
  
  /**
   * Generates and updates the chart based on the provided data.
   * 
   * This method processes the input data to calculate various metrics 
   * and prepares the data for rendering in the chart. It handles different 
   * chart types and updates the chart instance accordingly. 
   * 
   * @param data - An array of data objects containing information for the chart.
   * Each object should include properties such as `stocking_date`, `yearweek`, 
   * `uvrCumulInBoxes`, `uvrCumulInPieces`, `uvrCumul`, `minStock`, `maxStock`, 
   * `apcCapacity`, `forcast`, and `count`.
   * 
   * The method also manages the display of a red dotted line for negative values 
   * and creates scatter plots for specific conditions.
   */
 
  
  graph(data_temp) {
    const data = this.removeaddedData(data_temp);
    if (this.chartInstance != null) {
      this.chartInstance.destroy();
    }
    // this.adjustchartWidth();
    data.forEach((val, index) => {
      let d = val;
      let sd = d.stocking_date;
      let yw = d.yearweek;

      if (!this.isStockingDateUpdate) {
        // Full value with sequence
        val.yearWeekMonDateCR = `${sd.substring(2, 4)}${yw.substring(4, 6)}-${sd.substring(4, 6)}${sd.substring(6, 8)}-${d.sequence}-${sd.substring(9)}`;
        val.stocking_date = `${val.stocking_date?.split(' ')[0]} ${val.sequence} ${val.container_renban}`;
        // Display value without sequence
        val.yearWeekMonDateCRDisplay = `${sd.substring(2, 4)}${yw.substring(4, 6)}-${sd.substring(4, 6)}${sd.substring(6, 8)}${sd.substring(9)}`;
        if (d.taps_container) {
          val.yearWeekMonDateCR = `(T) ${val.yearWeekMonDateCR}`;
          val.yearWeekMonDateCRDisplay = `(T) ${val.yearWeekMonDateCRDisplay}`;
        }
      }
      let NaN_value = null;
      if (this.selectedchart.id == 1) {
        // selected chart type lot
        val.uvrChart = val.uvrCumulInBoxes;
        // val.uvrChartPieces = val.uvrCumulInPieces;
        val.forcast = val.uvrCumulInBoxes;
        // val.apc = val.apcCapacity;

        val.minNew = val.minStock;
        val.maxNew = val.maxStock;
        let TitleApc = this.chartResponse?.apc || 0;
        if (this.chartResponse?.apc) this.title(TitleApc);
        val.countNew = val.count != '' ? parseFloat(val.count) : 0; // Initialize count
        if (!Number.isNaN(val.countNew)) {
          val.uvrChart = val.countNew;
        } else {
          val.uvrChart = val.uvrCumulInBoxes;
        }
      } else if (this.selectedchart.id == 2) {
        // selected chart type peaces
        val.uvrChart = val.uvrCumulInPieces;
        val.forcast = val.uvrCumulInPieces;

        let TitleApc = (this.chartResponse?.apc || 0) * (this.chartResponse?.orderLot || 0);

        // val.minNew = val.minStock;
        // val.maxNew = val.max_pieces != '' ? parseFloat(val.max_pieces) : 0;
        val.countNew = val.count_pieces != '' ? parseFloat(val.count_pieces) : 0; // Initialize count_pieces
        if (!Number.isNaN(val.countNew)) {

          val.uvrChart = val.countNew;
        } else {
          val.uvrChart = val.uvrCumulInPieces;
        }
        if (this.chartResponse?.apc) this.title(TitleApc);
      } else if (this.selectedchart.id == 3) {
        // selected chart type days
        //uvr_pieces/req
        val.uvrChart = val.uvrCumul;
        val.forcast = val.uvrCumul;

        // val.minNew = val.min_pieces != '' ? roundUp(val.min_pieces/val.uvr_by_day_req,6) : 0;
        // val.maxNew = val.max_pieces != '' ? roundUp(val.max_pieces/val.uvr_by_day_req,6) : 0;

        // val.apc = this.chartResponse?.apc != ''? roundUp((this.chartResponse.apc/val.uvr_by_day_req) *  (this.chartResponse?.orderLot || 0),6): 0;
        // apc = apc / UvrBy_days_req * Order_Lots
        val.countNew = val.count != '' ? parseFloat(val.count) : 0; // Initialize count_pieces
        if (!Number.isNaN(val.countNew)) {
          val.uvrChart = val.countNew;
        } else {
          val.uvrChart = val.uvrCumul;
        }
        let TitleApc = this.chartResponse?.apc || 0;
        if (this.chartResponse?.apc) this.title(TitleApc);
      }
      if (d.container_renban != undefined && d.container_renban === '4CAST') {
        val.uvrChart = '';
      } else {
        val.forcast = '';
      }
      if (d.container_renban != undefined && d.container_renban === '4CAST' && index != 0) {
        if (data[index - 1].container_renban === undefined || data[index - 1].container_renban != '4CAST') {
          data[index - 1].forcast = data[index - 1].uvrChart;
        }
      }
      if (d.container_renban != undefined && d.container_renban !== '4CAST' && index != 0) {
        if (data[index - 1].container_renban === undefined || data[index - 1].container_renban === '4CAST') {
          val.forcast = val.uvrChart;
        }
      }
    });
    const hasNegativeY = data.some(
      (d) => d.uvrChart < 0 || d.maxStock < 0 || d.minStock < 0 || d.apcCapacity < 0 || d.forcast < 0 || d.countNew < 0
    );

    let redDottedLineSeries = [];

    if (hasNegativeY) {
      // Step 2: Find the first data point where any y-axis value is positive
      const firstPositiveIndex = data.findIndex(
        (d) =>
          d.uvrChart > 0 || d.maxStock > 0 || d.minStock > 0 || d.apcCapacity > 0 || d.forcast > 0 || d.countNew > 0
      );

      if (firstPositiveIndex !== -1) {
        const point = data[firstPositiveIndex];

        // Step 3: Get the smallest non-negative y-value at that point
        const yValues = [
          point.uvrChart,
          point.maxStock,
          point.minStock,
          point.apcCapacity,
          point.forcast,
          point.countNew,
        ].filter((v) => v !== null && v >= 0); // ✅ include 0 as valid

        const firstPositiveY = Math.min(...yValues);

        // Step 4: Create a new series starting from that index
        const redDottedLineData = data.slice(firstPositiveIndex).map((d) => ({
          yearWeekMonDateCR: d.yearWeekMonDateCR,
          uvrChart: firstPositiveY,
        }));

        // Step 5: Define the red dotted line series
        redDottedLineSeries = [
          {
            data: redDottedLineData,
            type: 'line',
            xKey: 'yearWeekMonDateCR',
            yKey: 'uvrChart',
            stroke: '#FF0000',
            yName: 'APFC',
            marker: { enabled: false },
            title: 'Red Dotted Line',
            lineDash: [4, 4],
            tooltip: { enabled: false },
            showInLegend: false,
          },
        ];
      }
    }

    const createLineLegendItem = (stroke: string) => ({
      marker: {
        shape: 'line',
        stroke,
        strokeWidth: 3,
        size: 20,
        color: stroke, // Set the color to match the stroke
      }

    });
    // const seriesColorMap = {
    //   'UVR': '#369336',
    //   'MAX': '#4258c9',
    //   'MIN': '#ed5f2c',
    //   'Safety': '#ffc800',
    //   'Forcast': '#808080',
    //   'Count': '#dbe90e',
    //   'Tapping': '#db23a1',
    //   'Airfreight': '#c169e3',
    //   'Using Point': '#67dce3'

    // };
    // if (firstChartploat) {
      let last_count = 0;
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (!Number.isNaN(element.countNew) && index != 0) {
          const newElement = data[index];
          let newdata = { ...newElement }
          // if (this.selectedchart.id == 1) {
          newdata.uvrChart = newdata.uvrChart - element.countNew + parseFloat(last_count + '');
          // if(this.selectedchart.id == 1 || this.selectedchart.id == 3){
          //   last_count = element.countInBoxes;
          // }else if(this.selectedchart.id == 2){
          //   last_count = element.countInPieces;
          // }
          newdata.count = null;
          newdata.countNew = null;
          newdata.addtoexcel = false;
          data.splice(index, 0, newdata);
          // last_count = element.countNew;
          index++;
        }
        // else if(!Number.isNaN(element.countInBoxes)){
          if(this.selectedchart.id == 1 || this.selectedchart.id == 3){
            last_count = element.countInBoxes;
          }else if(this.selectedchart.id == 2){
            last_count = element.countInPieces;
          }
        // }
      }
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (!Number.isNaN(element.countNew) && element.countNew != null && index != 0) {
          const newElement = data[index];
          let newdata = { ...newElement }
          newdata.uvrChart = null;
          newdata.count = null;
          newdata.addtoexcel = false;
          data.splice(index, 0, newdata);
          index++;
        }
      }
    // }
    console.log(data);
    this.options = {
      container: document.getElementById('myChart'),
      // title: {
      // text: this.chartTitle,
      // },
      // blue  '#4258c9',
      series: [
        {
          data: data,
          type: 'line',
          xKey: 'yearWeekMonDateCR',
          yKey: 'uvrChart',
          stroke: '#369336',
          yName: 'UVR',
          marker: { enabled: false, fill: '#369336' },
          title: 'UvR',
          color: '#369336',
          label: {
            enabled: true,
            color: '#369336',
          },
          legendItem: createLineLegendItem('#369336'),
        },

        {
          data: data,
          type: 'line',
          xKey: 'yearWeekMonDateCR',
          yKey: 'maxStock',
          stroke: '#4258c9',
          yName: 'MAX',
          marker: { enabled: false, fill: '#4258c9' },
          title: 'Max',
          legendItem: createLineLegendItem('#4258c9'),
        },
        {
          data: data,
          type: 'line',
          xKey: 'yearWeekMonDateCR',
          yKey: 'minStock',
          stroke: '#ed5f2c',
          yName: 'MIN',
          marker: { enabled: false, fill: '#ed5f2c' },
          title: 'Min',
          legendItem: createLineLegendItem('#ed5f2c'),
        },
        {
          data: data,
          type: 'line',
          xKey: 'yearWeekMonDateCR',
          yKey: 'apcCapacity',
          stroke: '#ffc800',
          yName: 'Safety',
          marker: { enabled: false, fill: '#ffc800' },
          title: 'Safety',
          color: '#ffc800',
          legendItem: createLineLegendItem('#ffc800'),
        },
        {
          data: data,
          type: 'line',
          xKey: 'yearWeekMonDateCR',
          yKey: 'forcast',
          stroke: '#808080',
          yName: 'Forcast',
          marker: { enabled: false, fill: '#808080' },
          title: 'Forecast',
          lineDash: [4, 4],
          legendItem: {
            marker: {
              shape: 'line',
              size: 20,
              strokeWidth: 3,
            },
          },
        },
        {
          type: 'scatter',
          data: data.filter((x) => { return x.count; }).length > 0 ? data.filter((x) => x.count) : [{ yearWeekMonDateCR: '', uvrChart: null }],
          xKey: 'yearWeekMonDateCR',
          yKey: 'uvrChart',
          yName: 'Count',
          xName: 'Stocking Date',
          marker: { enabled: true, shape: 'circle', size: 10, fill: '#dbe90e' },
          showInLegend: true,
        },
        {
          type: 'scatter',
          data:
            data.filter((x: { container_renban: string }) => x.container_renban.trim().startsWith('TAP')).length > 0
              ? data.filter((x: { container_renban: string }) => x.container_renban.trim().startsWith('TAP'))
              : [{ yearWeekMonDateCR: '', uvrChart: null }],
          xKey: 'yearWeekMonDateCR',
          yKey: 'uvrChart',
          yName: 'Tapping',
          xName: 'Stocking Date',
          marker: { enabled: true, shape: 'cross', size: 10, fill: '#db23a1' },
          showInLegend: true,
          tooltip: {
            renderer: (params) => {
              // console.log('params', params);

              return {
                content: `Stocking Date: ${params.xValue}
                    ${this.selectedchart.id === 1 ? `<br>No of lots: ${params.datum.usage_v_receipt}` : `<br>No of Pieces: ${params.datum.uvr_pieces}`
                  }`,
              };
            },
          },
        },
        {
          type: 'scatter',
          data:
            data.filter((x: { container_renban: string }) => x.container_renban.startsWith('AIRFR')).length > 0
              ? data.filter((x: { container_renban: string }) => x.container_renban.startsWith('AIRFR'))
              : [{ yearWeekMonDateCR: '', uvrChart: null }],
          xKey: 'yearWeekMonDateCR',
          yKey: 'uvrChart',
          yName: 'Airfreight',
          xName: 'Stocking Date',
          marker: { enabled: true, shape: 'triangle', size: 10, fill: '#c169e3' },
          showInLegend: true,
          legendItem: {
            marker: {
              shape: 'triangle',
              size: 20,
              strokeWidth: 3,
            },
          },
          tooltip: {
            renderer: (params) => {
              // console.log('params', params);

              return {
                content: `Stocking Date: ${params.xValue}<br>Airfreight: ${params.yValue}
                          ${this.selectedchart.id === 1
                    ? `<br>No of lots: ${params.datum.usage_v_receipt}`
                    : `<br>No of Pieces: ${params.datum.uvr_pieces}`
                  }`,
              };
            },
          },
        },
        {
          type: 'scatter',
          data: data.filter((x) => x.container_renban === 'USE-P').length > 0 ? data.filter((x) => x.container_renban === 'USE-P') : [{ yearWeekMonDateCR: '', uvrChart: null }],
          xKey: 'yearWeekMonDateCR',
          yKey: 'uvrChart',
          yName: 'Using Point',
          marker: { enabled: true, shape: 'diamond', size: 10, fill: '#67dce3' },
          showInLegend: true,
          legendItem: {
            marker: {
              shape: 'diamond',
              size: 20,
              strokeWidth: 3,
            },
          },
        },
        ...redDottedLineSeries,
      ],
      axes: [
        {
          type: 'category',
          position: 'bottom',
          label: {
            rotation: 270,
            formatter: (params) => {
              // return params.index % 1 === 0 || params.value?.includes('(T)') ? params.value : '';
              if (data.length > 200)
                return params.index % 3 === 0 || params.value?.includes('(T)') || (params.index == (data.length - 1)) ? params.value : '';
              else if (data.length > 100)
                return params.index % 2 === 0 || params.value?.includes('(T)') || (params.index == (data.length - 1)) ? params.value : '';
              else
                return params.index % 1 === 0 || params.value?.includes('(T)') || (params.index == (data.length - 1)) ? params.value : '';
            },
            // padding: 1,
            fontSize: 8,
          },
          line: {
            color: '#000000',
            width: 1,
          },
        },
        {
          type: 'number',
          position: 'left',
          line: {
            color: '#000000',
            width: 1,
          },
          label: {
            color: '#000000',
          },
        },
      ],
      legend: {
        position: 'bottom',
        item: {
          label: {
            fontWeight: 'normal',
            fontSize: 10,
            formatter: ({ value }) => {
              if (value === 'UvR' || value === 'Max' || value === 'Min' || value === 'Safety' || value === 'Forecast') {
                const underlined = value.split('').map(char => char + '\u0332').join('');
                return underlined;
              }
              return value;
            },
          },
          toggleSeriesVisible: true,
        },
      },
    };
    this.chartInstance = AgChart.create(this.options);
    this.spinner.hide();
  }


  divWidth = 100;
  // firstChartploat = true;
  // adjustchartWidth() {
  //   this.divWidth = this.UsageVersusReceipt.length <= 120 ? 100 
  //       : this.UsageVersusReceipt.length <= 160 ? 110 
  //           : this.UsageVersusReceipt.length <= 200 ? 120 : 130
  //   // this.divWidth = 130;
  // }
  expendChart() {
    if (this.divWidth <= 150)
      this.divWidth += 5;
  }
  resetChart() {
    this.divWidth = 100;
  }
  shrinkChart() {
    if (this.divWidth > 100)
      this.divWidth -= 5;
  }  
}